import styled from 'styled-components';

export const ContainerBreadcrumb = styled.nav`
  width: 100%;
  padding: 4px 0 6px;
  margin: 0;
  background: transparent;
`;

export const UlBreadcrumb = styled.ol`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 1.35;
  background: transparent;
  border-radius: 0;

  & > li {
    display: inline-flex;
    align-items: center;
    color: #5c6a7a;
    max-width: 100%;

    &:not(:last-child)::after {
      content: '/';
      margin: 0 8px;
      color: rgba(21, 43, 78, 0.22);
      font-weight: 400;
      font-size: 11px;
      user-select: none;
    }

    & > a {
      color: #152b4e;
      text-decoration: none;
      font-weight: 500;
      opacity: 0.88;
      transition: color 0.15s ease, opacity 0.15s ease;

      &:hover {
        color: #1a3562;
        opacity: 1;
        text-decoration: underline;
        text-underline-offset: 2px;
      }
    }
  }

  /* Página atual: só destaque tipográfico (mesmo fundo da barra) */
  & > li.breadcrumb-current {
    color: #152b4e;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 0;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;

    &::after {
      display: none;
    }
  }

  ${props => {
    const { getMedias: { iphones } } = props.theme;
    return `
      ${iphones()`
        padding-left: 0;
        padding-right: 0;
        font-size: 11px;

        & > li.breadcrumb-current {
          font-size: 11px;
        }
        `
      }
    `;
  }}
`;
